import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { addSubCategory } from 'action/category'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import CategoryForm from 'view/page/category-management/component/category-form'
import FormModal from 'view/component/form-modal'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'Sub Category created'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const NewSubCategory = ({ addSubCategory, categoryUuid, submitting, special, userTypes, specialGroup }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await addSubCategory(categoryUuid, values)
      setVisible(false)
      form.resetFields()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>New Sub Category</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.resetFields()
        }}
        title='New Sub Category'
        visible={visible}
      >
        {special
              ? <>
                <CategoryForm
                  category={{ special, special_group: specialGroup, user_type_uuids: [userTypes[0]?.uuid || specialGroup[0]?.uuid] }}
                  categoryUuid={categoryUuid}
                  form={form}
                  subCat={true}
                />
              </>
              : <>
                <CategoryForm
                  categoryUuid={categoryUuid}
                  form={form}
                  subCat={true}
                />
              </>}
      </FormModal>
    </>
  )
}

NewSubCategory.propTypes = {
  addSubCategory: PropTypes.func,
  categoryUuid: PropTypes.string,
  special: PropTypes.bool,
  specialGroup: PropTypes.array,
  submitting: PropTypes.bool,
  userTypes: PropTypes.array
}

const mapStateToProps = ({ category, loader }, { categoryUuid }) => ({
  special: categoryUuid
    ? (category.managementCategories.find(({ uuid }) => uuid === categoryUuid)).special
    : false,
  specialGroup: categoryUuid
    ? (category.managementCategories.find(({ uuid }) => uuid === categoryUuid)).special_group
    : null,
  submitting: loader.categorySubmitting,
  userTypes: categoryUuid
    ? (category.managementCategories.find(({ uuid }) => uuid === categoryUuid)).user_types
    : null
})

const mapDispatchToProps = (dispatch) => ({
  addSubCategory: bindActionCreators(addSubCategory, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(NewSubCategory)
